/**
 * @file SiteFooter.tsx
 * @description Global footer with copyright, links, and basic company info.
 */

/**
 * SiteFooter component renders the website footer.
 */
export function SiteFooter() {
  return (
    <footer className="border-t border-slate-800 bg-slate-950">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-8 text-sm text-slate-400 md:flex-row md:items-center md:justify-between md:px-6">
        <div>
          <p className="font-semibold text-slate-200">Ultimind Pte. Ltd.</p>
          <p className="mt-1">
            Singapore HQ · Hangzhou R&amp;D Center · Agentic AI for enterprises.
          </p>
          <p className="mt-1 text-xs">
            © {new Date().getFullYear()} Ultimind. All rights reserved.
          </p>
        </div>
        <div className="flex flex-wrap gap-4">
          <a href="#/privacy" className="hover:text-sky-400">
            Privacy Policy
          </a>
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noreferrer"
            className="hover:text-sky-400"
          >
            LinkedIn
          </a>
          <a
            href="mailto:contact@ultimind.ai"
            className="hover:text-sky-400"
          >
            Email
          </a>
        </div>
      </div>
    </footer>
  )
}
